/**
 * TODO:VUE全局扩展方法
 */
import store from './../../store/index'
import axios from 'axios'


export default {
  install(vue, options) {
    vue.prototype.$http = axios
    vue.prototype.pageSize = 10
    vue.prototype.clinicStatus = function (status) {
      switch (status) {
        case -3:
          return 'danger'
        case -2:
          return 'warning'
        case -1:
          return 'info'
        case 0:
          return ''
        case 1:
          return 'success'
        case 2:
          return 'success'
        case 3:
          return 'success'
      }
    }
    vue.prototype.askStatus = function (status) {
      switch (status) {
        case 1:
          return 'danger'
        case 2:
          return 'success'
        case 3:
          return 'info'
      }
    }
    vue.prototype.clone = function (params, arg = {}) {
      let item = arg
      for (let key of Object.keys(params)) {
        if (Array.isArray(params[key])) {
          item[key] = vue.prototype.clone(params[key], [])
        } else if (params[key] instanceof Object) {
          item[key] = Object.assign({}, params[key])
        } else {
          item[key] = params[key]
        }
      }
      return item
    }
    vue.prototype.httpToHttps = function(url){
      if(url.indexOf('http://') > -1){
        return url.replace(/^http:\/\//,'https://')
      }
      return url
    },
    vue.prototype.$http.interceptors.response.use(function (response) {
      store.commit('updateLoadingStatus', {isLoading: false})
       return response;

      // Do something with response data
      let resp = {}
      if (response.data.status) {
        vue.$vux.toast.show({
          text: response.data.msg,
          type: 'cancel'
        })
        if (response.data.status === -1) {
          sessionStorage.removeItem('token')
          window.location.replace('/')
        }
        resp.resp = {}
      } else {
        resp.resp = response.data.data || response.data
      }
      store.commit('updateLoadingStatus', {isLoading: false})
      return resp
    }, function (error) {
      /*vue.$vux.toast.show({
        text: '服务器异常',
        type: 'cancel'
      })*/
      // Do something with response error
      store.commit('updateLoadingStatus', {isLoading: false})
      return Promise.reject(error)
    })
    vue.prototype.ageFormart = function (birthday, end) {
      let _month = 30.4368
      let _birthday = 0
      let now = Date.now()
      // 如果传入终止日期则用end去计算
      if (end) {
        try {
          now = new Date(end.replace(/-/g, '/')).getTime()
        } catch (e) {
          now = new Date(end).getTime()
        }
      }
      try {
        _birthday = birthday.replace(/-/g, '/')
      } catch (e) {
        _birthday = birthday
      }
      _birthday = now - new Date(_birthday).getTime()
      let year = Math.floor(_birthday / (12 * _month * 24 * 60 * 60 * 1000))
      let month = Math.floor((_birthday % (12 * _month * 24 * 60 * 60 * 1000) / (12 * _month * 24 * 60 * 60 * 1000)) * 12)
      if (year !== 0 && !year) {
        return ''
      }
      return `${year}岁${month}个月`
    }
    vue.prototype.babyAge = function (birthday, end) {
      let _month = 30.4368
      let _birthday = 0
      let now = Date.now()
      // 如果传入终止日期则用end去计算
      if (end) {
        try {
          now = new Date(end.replace(/-/g, '/')).getTime()
        } catch (e) {
          now = new Date(end).getTime()
        }
      }
      try {
        _birthday = birthday.replace(/-/g, '/')
      } catch (e) {
        _birthday = birthday
      }
      _birthday = now - new Date(_birthday).getTime()
      return Math.floor(_birthday / (12 * _month * 24 * 60 * 60 * 1000))
    }
    // 本地存储封装
    /**
     * 传入参数是读写
     * @param item
     * 对象：写入操作，字符串：都操作，不传参返回清除函数接受键
     * @returns {function(*=)}
     */
    vue.prototype.storage = (item) => {
      if (item instanceof Object) {
        for (let key of Object.keys(item)) {
          let _item = item[key]
          if (typeof _item === 'object') {
            _item = JSON.stringify(_item)
          }
          sessionStorage.setItem(key, _item)
        }
      } else if (item) {
        try {
          return JSON.parse(sessionStorage.getItem(item))
        } catch (e) {
          // console.warn(`${item}不是对象`)
          return sessionStorage.getItem(item)
        }
      } else {
        return (key) => {
          sessionStorage.removeItem(key)
        }
      }
    }
    vue.prototype.pickerOptionsNext = {
      disabledDate(time) {
        return time.getTime() <= Date.now()
      }
    }
    vue.prototype.pickerOptionsFast = {
      disabledDate(time) {
        return time.getTime() > Date.now()
      },
      shortcuts: [{
        text: '今天',
        onClick(picker) {
          picker.$emit('pick', new Date())
        }
      }, {
        text: '昨天',
        onClick(picker) {
          const date = new Date()
          date.setTime(date.getTime() - 3600 * 1000 * 24)
          picker.$emit('pick', date)
        }
      }, {
        text: '一周前',
        onClick(picker) {
          const date = new Date()
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', date)
        }
      }]
    }
    vue.prototype.updatePage = function (self, pageNo) {
      let route = Object.assign({}, self.$route)
      let p = Object.assign(route, {
        query: {
          pageNo: pageNo
        }
      })
      self.$router.replace(p)
    }
    vue.prototype.getPageNo = function (self) {
      return (Number(self.$route.query.pageNo) || 1)
    }
    /**
     * 验证
     * @param self
     * this
     * @returns {string}
     * 返回验证信息，如果验证不通过则返回错误信息，验证通过则返回空串
     */
    vue.prototype.validate = function (self) {
      let error = ''
      for (let key of Object.keys(self.rules)) {
        let obj = self.rules[key]
        obj.map(item => {
          let data = ''
          try {
            data = (self[self.formData][key] || '').replace(/\s+/g, '')
          } catch (e) {
            data = self[self.formData][key]
          }
          if (item.required && !data) {
            error = item
          } else if (item.pattern && !item.pattern.test(data)) {
            error = item
          }
        })
        if (error) {
          return error
        }
      }
    }







    vue.prototype.setCookie =  function (name, value, days) {
      var d = new Date;
      if(!days) {
        days = 30;
      }
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      window.document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    };
    //获取cookie、
    vue.prototype.getCookie =  function (name) {
      var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        return (arr[2]);
      else
        return null;
    };

   //删除cookie
    vue.prototype.delCookie = (name) => {
      var d = new Date();
      d.setTime(d.getTime() + (-10 * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toGMTString();
      document.cookie = name + "=" + '' + ";path=/;" + expires;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/vue.extended.js